import { useEffect, useState } from "react";
import { Button, FormControl, TextField } from "@mui/material";
import { Add } from "@mui/icons-material";
import AddOrEditBasicEntity from "../../../components/common/AddOrEditBasicEntity";
import {
  getClearEvidenceTypeForTemplate,
  getEvidenceType,
  getListFromJson,
} from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";
import { EvidenceTypeEnum } from "../../../common/utils";
import Combobox from "../../../components/common/Combobox";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import EvidenceTempleateItem from "./EvidenceTemplateItem";
import NotificationItem from "../../../components/common/NotificationItem";
import ExpandableView from "../../../components/common/ExpandableView";
import CreatedByText from "../../../components/common/CreatedByText";

export default function AddOrEditEvidenceTemplate({ model, setModel }) {
  const [evidencesList, setEvidencesList] = useState([]);
  const [newEvidence, setNewEvidence] = useState(
    getClearEvidenceTypeForTemplate()
  );

  const handleNewEvidenceDataChange = (e) => {
    setNewEvidence({
      ...newEvidence,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddButton = () => {
    addEvidence(newEvidence);
    setNewEvidence(getClearEvidenceTypeForTemplate());
  };

  const handleNewEvidenceTypeChange = (type) => {
    setNewEvidence({
      ...newEvidence,
      Type: type?.Id ?? 1,
    });
  };

  const getNewEvidencePanel = () => (
    <div
      className="flex my-4 gap-2"
      style={{
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <FormControl required fullWidth>
        <TextField
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
          size="small"
          fullWidth
          id="outlined-basic"
          name="Name"
          label={localize.name}
          variant="outlined"
          onChange={handleNewEvidenceDataChange}
          value={newEvidence.Name}
        />
      </FormControl>
      <Combobox
        id="Type"
        handleValueChange={handleNewEvidenceTypeChange}
        fieldValue={{
          Id: newEvidence.Type,
          Name: getEvidenceType(newEvidence.Type),
        }}
        fieldOptions={[
          {
            Id: EvidenceTypeEnum.Image,
            Name: getEvidenceType(EvidenceTypeEnum.Image),
          },
          {
            Id: EvidenceTypeEnum.Audio,
            Name: getEvidenceType(EvidenceTypeEnum.Audio),
          },
          {
            Id: EvidenceTypeEnum.Video,
            Name: getEvidenceType(EvidenceTypeEnum.Video),
          },
        ]}
        fieldLabel={localize.type}
      />
      <Button
        size="small"
        variant="contained"
        color="success"
        className="app_general_button_data app_success_button btn-sm"
        onClick={handleAddButton}
        disabled={!newEvidence.Name || newEvidence.Name.length === 0}
      >
        <Add className="text-lg" />
      </Button>
    </div>
  );

  const getEvidencesTable = () => (
    <div className="flex flex-col gap-2">
      {getNewEvidencePanel()}

      {evidencesList && evidencesList.length > 0 ? (
        evidencesList.map((evidence) => (
          <EvidenceTempleateItem
            evidence={evidence}
            onDeleteEvidence={() => {
              removeEvidence(evidence.Id);
            }}
          />
        ))
      ) : (
        <NotificationItem
          notification={{
            type: 0,
            message: localize.no_evidences,
          }}
        />
      )}
    </div>
  );

  const addEvidence = (evidence) => {
    evidencesList.push(evidence);
    setModel({
      ...model,
      Photos: JSON.stringify(evidencesList),
    });
  };

  const removeEvidence = (id) => {
    const index = evidencesList.findIndex((x) => x.Id === id);
    if (index >= 0) {
      evidencesList.splice(index, 1);
      setEvidencesList([...evidencesList]);
      setModel({
        ...model,
        Photos: JSON.stringify(evidencesList),
      });
    }
  };

  useEffect(() => {
    if (model?.Photos) {
      const list = getListFromJson(model?.Photos);
      setEvidencesList(list);
    }
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <ExpandableView
        components={[
          {
            Name: localize.general_information,
            Component: (
              <div className="w-full my-4">
                <AddOrEditBasicEntity
                  model={model}
                  setModel={setModel}
                  customWidth="100%"
                />
              </div>
            ),
          },
          {
            Name: localize.evidences,
            Component: getEvidencesTable(),
          },
        ]}
      />

      <CreatedByText entity={model} />
    </div>
  );
}
